<template>
  <v-app id="app" style="background-color: #fff" class="">
    <div v-if="!isAuthChromeHidden">
      <NavigationMenu :menuStatus="menuStatus" />
    </div>
    <DrawerMenu v-if="!isAuthChromeHidden" :menuStatus="menuStatus" />
    <FooterMenu v-if="!isAuthChromeHidden" />
    <v-main
      :class="[
        'main-app-screen',
        {
          'main-app-screen--full': isFullScreenMobileRoute,
          'main-app-screen--auth': isAuthChromeHidden,
        },
      ]"
    >
      <transition name="fade">
        <router-view :key="$route.fullPath" />
      </transition>
    </v-main>

    <div app>
        <v-snackbar
          timeout="10000"
          v-model="$store.state.app.snackbar.value"
          max-width="90%"
          right
          :style="isAuthChromeHidden ? 'margin-bottom: 24px; z-index: 9999' : 'margin-bottom: 70px; z-index: 9999'"
        >
        <div v-if="$store.state.app.snackbar.type == 1" class="d-flex">
          <div class="mr-2 pt-2">
            <div style="background-color: #d5fbd8; border-radius: 50%; width: 32px; height: 32px" class="pt-1 pl-1">
              <v-icon color="green">check_circle</v-icon>
            </div>
          </div>
          <div class="d-block">
            <div>
              <strong style="font-family: 'Montserrat', sans-serif">Sucesso!</strong>
            </div>
            <div>
              <span style="font-family: 'Montserrat', sans-serif">{{ $store.state.app.snackbar.text }}</span>
            </div>
          </div>
          <div>
            <v-btn text @click="closeSnackbar" color="#fff"> <strong>OK</strong></v-btn>
          </div>
        </div>
        <div v-if="$store.state.app.snackbar.type == 2" class="d-flex">
          <div class="mr-2 pt-1">
            <div style="background-color: #ffe8e8; border-radius: 50%; width: 32px; height: 32px" class="pt-1 pl-1">
              <v-icon color="red" outlined>cancel</v-icon>
            </div>
          </div>
          <div class="d-block">
            <div>
              <strong style="font-family: 'Montserrat', sans-serif">Ops, algo deu errado!</strong>
            </div>
            <div>
              <span style="font-family: 'Montserrat', sans-serif">{{ $store.state.app.snackbar.text }}</span>
            </div>
          </div>
          <div>
            <v-btn text @click="closeSnackbar" color="#fff"> <strong>OK</strong></v-btn>
          </div>
        </div>
        <div v-if="$store.state.app.snackbar.type == 3" class="d-flex">
          <div class="d-block">
            <div>
              <strong style="font-family: 'Montserrat', sans-serif">Aviso de cookies</strong>
            </div>
            <div>
              <span style="font-family: 'Montserrat', sans-serif">{{ $store.state.app.snackbar.text }}</span>
            </div>
          </div>
          <div>
            <v-btn text @click="closeSnackbar" color="#fff"> <strong>OK</strong></v-btn>
          </div>
        </div>
        <div v-if="$store.state.app.snackbar.type == 4" class="d-flex">
          <div class="mr-2 pt-1">
            <div style="background-color: #fff3cd; border-radius: 50%; width: 32px; height: 32px" class="pt-1 pl-1">
              <v-icon color="primary">mdi-forum-outline</v-icon>
            </div>
          </div>
          <div class="d-block">
            <div>
              <strong style="font-family: 'Montserrat', sans-serif">Nova mensagem</strong>
            </div>
            <div>
              <span style="font-family: 'Montserrat', sans-serif">{{ $store.state.app.snackbar.text }}</span>
            </div>
          </div>
          <div>
            <v-btn text @click="closeSnackbar" color="#fff"> <strong>OK</strong></v-btn>
          </div>
        </div>
      </v-snackbar>
    </div>
  </v-app>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { ROUTERS } from "./router/router";
import { APP_SET_LOGIN, APP_SET_MENU, HIDE_SNACK } from "./store/MUTATIONS-TYPES";
import { bootstrapChatSession } from "./services/chatHub";

@Component({
  components: {
    NavigationMenu: () => import("@/components/navigationMenu"),
    FooterMenu: () => import("@/components/footer"),
    DrawerMenu: () => import("@/components/drawerMenu"),
  },
})
export default class App extends Vue {
  setLogin!: any;
  setMenu!: any;
  mobileView: boolean = false;
  showNav: boolean = false;

  async created() {
    this.getStatus();
  }

  mounted() {
    bootstrapChatSession();
  }

  getStatus() {
    this.setLogin = localStorage.getItem(APP_SET_LOGIN);
  }

  get isAuthChromeHidden() {
    return Boolean(this.$route?.meta?.hideChrome);
  }

  get menuStatus() {
    if (this.isAuthChromeHidden) {
      return "hidden";
    }
    if (this.$route?.meta?.hideMobileNav && this.$store.getters.currentIsMobileDevice) {
      return "hidden";
    }
    const status = localStorage.getItem(APP_SET_MENU);
    return status;
  }

  get isFullScreenMobileRoute() {
    return Boolean(this.$route?.meta?.hideMobileNav && this.$store.getters.currentIsMobileDevice);
  }

  openLogin() {
    this.fillOpt("false");
    this.$router.push(ROUTERS.ACCESS_CONTROL.LOGIN.PATH);
  }

  fillOpt(value: string) {
    localStorage.setItem(APP_SET_LOGIN, "true");
    this.setLogin = localStorage.getItem(APP_SET_LOGIN);
  }

  closeSnackbar() {
    const { commit } = this.$store;
    commit(HIDE_SNACK);
  }

  getGeolocation() {
    if ("geolocation" in navigator) {
      const watcher = navigator.geolocation.watchPosition(
        function (position) {},
        function (error) {
          console.log(error);
        },
        {
          enableHighAccuracy: true,
          maximumAge: 30000,
          timeout: 30000,
        }
      );
    } else {
      alert("Encontramos um problema com sua localização.");
    }
  }
}
</script>

<style>
@import "@mdi/font/css/materialdesignicons.css";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
  position: absolute;
  width: 100%;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
